import { useFormikContext } from 'formik';
import { useDebouncedValue } from '@ianesthesie-kit/core';
import { useEffect } from 'react';
import { useAppDispatch } from '@/hooks';
import { patchNewPatientFormValues } from '@/modules/appContext';
import { CombinedPatientSchema } from './patient.schema';

export const ReduxFormValuesListener = () => {
  const { values } = useFormikContext<CombinedPatientSchema>();
  const debounced = useDebouncedValue(values, 600);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(patchNewPatientFormValues(debounced));
  }, [dispatch, debounced]);

  return null;
};
